import { createFileRoute } from '@tanstack/react-router';

import { RecoveryPage } from '../../pages/auth';

export const Route = createFileRoute('/auth/reset-password')({
  validateSearch: (search: Record<string, unknown>): { token?: string } => ({
    token: typeof search.token === 'string' ? search.token : undefined,
  }),
  component: () => <RecoveryPage token={Route.useSearch().token} />,
});
